import React from 'react'
import Header from './components/Header/Header'
import MeSection from './components/Sections/Me/Me'
import Stats from './components/Sections/Stats/Stats'
import Work from './components/Sections/Work/Work'
import Experiences from './components/Sections/Experiences/Experiences'
import Projects from './components/Sections/Projects/Projects'
import Contact from './components/Sections/Contact/Contact'
import Footer from './components/Footer/Footer'
import GithubProjects from './components/Sections/Github/Github'
import WorkExperiances from './components/Sections/WorkExperiances/WorkExperiances'
import StickyCTA from './components/StickyCTA/StickyCTA'


const App = () => {
  return (
    <>
    <Header />
    <main>
      <MeSection />
      <Stats />
      <Work />
      <WorkExperiances />
      <Projects />
      <Experiences />
      <GithubProjects />
      <Contact />
    </main>
    <Footer />
    <StickyCTA />
    </>
  )
}

export default App
